import CapsuleIcon from 'src/app/components/Elements/CapsuleIcon';
import { CAPSULE_ICON_STRINGS } from 'src/consts';

export const PendingMedicationSVG = ({ numItems }: { numItems: number }) => {
  return (
    <svg width="58" height="100">
      <CapsuleIcon iconString={CAPSULE_ICON_STRINGS.checkout_allergy} x="0" y="5" width="48" height="87" raw block />
      <svg width="32" height="32" x="29" y={`${numItems > 9 ? '0' : '4'}`}>
        <g transform={`translate(${numItems > 9 ? '16,16' : '14,14'})`}>
          <circle cx="0" cy="0" r={numItems > 9 ? '14' : '12'} fill="#74A6A2" stroke="white" strokeWidth="2" />
          <text
            x="0"
            y="1"
            alignmentBaseline="middle"
            textAnchor="middle"
            fontFamily="Circular-Pro, Helvetica, Arial, sans-serif"
            fontSize="12"
            fontWeight="bold"
            fill="#fff"
          >
            {numItems}
          </text>
        </g>
      </svg>
    </svg>
  );
};
